import { render } from "./EmployeeBeneficiaryModal.vue?vue&type=template&id=451390be"
import script from "./EmployeeBeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./EmployeeBeneficiaryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__